import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import img from "../../../assets/images/login-form.jpg";
import logo from "../../../assets/images/logo.png";
import ResetPasswordForm from "./ResetPasswordForm";

const Picture = styled("picture")`
  display: block;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ResetPasswordContent = ({
  firstname,
  token,
}: {
  firstname: any;
  token: any;
}) => {
  const navigate = useNavigate();
  const [submited, setSubmited] = useState(false);
  return (
    <Paper
      sx={{
        display: "flex",
        maxWidth: 1000,
        width: "100%",
        minHeight: {
          xs: 0,
          sm: 630,
        },
        borderRadius: 2.5,
        bgcolor: "#fff",
      }}
    >
      <Box
        sx={{
          display: {
            xs: "none",
            sm: "block",
          },
          width: {
            xs: "none",
            sm: "30%",
            md: "50%",
          },
          borderRadius: 2.5,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          overflow: "hidden",
        }}
      >
        <Picture>
          <img src={img} alt="" />
        </Picture>
      </Box>
      <Box
        p={5}
        pb={10}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: {
            xs: "100%",
            sm: "70%",
            md: "50%",
          },
        }}
      >
        {/* Logo */}
        {submited ? (
          <>
            <Box
              textAlign="center"
              pt={{ xs: 5, lg: 20 }}
              maxWidth={363}
              mx="auto"
            >
              <Box mb={{ xs: 4, md: 8 }}>
                <img src={logo} alt="" />
              </Box>
              <Typography fontWeight={300}>
                Du har nu ændret din adgangskode
              </Typography>
            </Box>
            <Box maxWidth={280} width="100%" mx="auto" mt={10}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/auth");
                }}
                size="large"
              >
                Gå til login
              </Button>
            </Box>
          </>
        ) : (
          <>
            <Box
              textAlign="center"
              pt={{ xs: 5, lg: 20 }}
              maxWidth={363}
              mx="auto"
            >
              <Box mb={{ xs: 4, md: 8 }}>
                <img src={logo} alt="" />
              </Box>
              <Typography fontWeight={300}>
                Hej {firstname}
                <br />
                <br /> Her kan du ændre din adgangskode.
              </Typography>
            </Box>
            <Box maxWidth={280} width="100%" mx="auto" mt={10}>
              <ResetPasswordForm token={token} setSubmited={setSubmited} />
            </Box>
          </>
        )}
      </Box>
    </Paper>
  );
};

export default ResetPasswordContent;
